export interface BusinessContextSection {
  label: string;
  content: string;
}

const LABEL_PATTERN = /(Anliegen|Bezug|Referenzen|Optional Kontext):/gi;

function normalizeLineWhitespace(value: string): string {
  return value
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map((line) => line.replace(/\s+/g, ' ').trim())
    .filter(Boolean)
    .join('\n');
}

export function parseBusinessContextSections(value?: string | null): BusinessContextSection[] {
  const normalized = value?.replace(/\r\n?/g, '\n').trim() ?? '';
  if (!normalized) {
    return [];
  }

  const matches = Array.from(normalized.matchAll(LABEL_PATTERN));
  if (matches.length === 0) {
    return [];
  }

  return matches
    .map((match, index) => {
      const start = match.index ?? 0;
      const nextStart = matches[index + 1]?.index ?? normalized.length;
      const label = match[1];
      const content = normalizeLineWhitespace(normalized.slice(start + match[0].length, nextStart));
      return content ? { label, content } : null;
    })
    .filter((section): section is BusinessContextSection => section !== null);
}

export function normalizeBusinessContextBody(value?: string | null): string {
  return normalizeLineWhitespace(value ?? '');
}